import { DataType } from "../models/lookups";

export const buildStateMap = (states: DataType[]) => 
    new Map(states.map(s => [s.shortName.toUpperCase(), s.id]));

const specialStates = new Set([2, 8, 34, 41, 45, 50]);

export const parseToStateDistrict = (input: string, stateMap: Map<string, number>) => {
    const [stateShort, districtPart] = input.split('-');
    let district = Number(districtPart);

    let stateId = stateMap.get(stateShort.toUpperCase());

    if(stateId && specialStates.has(stateId)) district = 0;

    return { stateId, district};
}


export const isPrimaryScorecard = (name: string): boolean => /\d/.test(name) || /at[- ]?large/i.test(name);
